import React, { useEffect, useCallback } from 'react';

interface TicketFieldPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
}

const LIGHT_THEME_OVERRIDE: React.CSSProperties = {
  '--theme-text': '#1e293b',
  '--theme-muted-text': '#6b7280',
  '--theme-input-background': '#ffffff',
  '--theme-input-text': '#1e293b',
  '--theme-input-border': 'rgba(0, 0, 0, 0.10)',
  '--theme-input-focus': '#8b5cf6',
  '--theme-card-background': '#ffffff',
  '--theme-card-text': '#334155',
  '--theme-card-border': 'rgba(0, 0, 0, 0.06)',
  '--theme-card-muted': '#94a3b8',
  '--theme-button-primary': '#8b5cf6',
  '--theme-button-primary-text': '#ffffff',
  '--theme-primary': '#8b5cf6',
  '--theme-border': 'rgba(0, 0, 0, 0.06)',
  '--theme-component-background': '#ffffff',
} as React.CSSProperties;

export const TicketFieldPopover: React.FC<TicketFieldPopoverProps> = ({
  isOpen,
  onClose,
  children,
  width = 220,
}) => {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40"
        onClick={onClose}
      />
      {/* Popover */}
      <div
        className="absolute right-0 mt-1 z-50 rounded-lg shadow-lg border overflow-hidden"
        style={{
          width,
          backgroundColor: '#ffffff',
          borderColor: '#e5e7eb',
          ...LIGHT_THEME_OVERRIDE,
        }}
        role="listbox"
      >
        {children}
      </div>
    </>
  );
};
